<template>
  <div class="tasks-table">
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>
            <b-checkbox
              class="checkbox-only"
              :value="allTasksSelected"
              @input="onSelectAllChange"/>
          </th>
          <th
            v-for="header in tableHeaders"
            :key="`page_table_header_${header}`">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="tasks.length === 0">
          <td
            colspan="99"
            class="has-text-centered">
            {{ $t('tasks.table.empty') }}
          </td>
        </tr>
        <tasks-table-row
          v-for="task in tasks"
          :key="`task_${task.orderIdentifier}`"
          :task="task"
          :selectedTasks.sync="localSelectedTasks"
          :isCompleted="isCompleted"
          :isSearch="isSearch"/>
      </tbody>
    </table>
  </div>
</template>

<script>
const TasksTableRow = () => import('./TasksTableRow')

export default {
  name: 'tasks-table',
  components: {
    TasksTableRow
  },
  props: {
    tasks: {
      type: Array,
      required: true
    },
    selectedTasks: {
      type: Array,
      required: true
    },
    isCompleted: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allTasksSelected: false,
      localSelectedTasks: []
    }
  },
  computed: {
    tableHeaders() {
      const headers = [
        this.$t('tasks.table.headers.orderNumber')
      ]

      if (!this.isCompleted) {
        headers.push(
          this.$t('tasks.table.headers.status')
        )
      }

      headers.push(
        this.$t(`tasks.table.headers.${this.isSearch ? 'servingDateTime' : 'servingTime'}`)
      )

      headers.push(
        this.$t('tasks.table.headers.courier'),
        this.$t('tasks.table.headers.address'),
        this.$t('tasks.table.headers.customerDetails')
      )

      if (this.isCompleted) {
        headers.push(
          this.$t('tasks.table.headers.completedAt')
        )
      }

      return headers
    }
  },
  watch: {
    selectedTasks() {
      this.localSelectedTasks = this.selectedTasks
    },
    localSelectedTasks() {
      this.$emit('update:selectedTasks', this.localSelectedTasks)
      this.allTasksSelected = this.localSelectedTasks.length === this.tasks.length && this.localSelectedTasks.length > 0
    }
  },
  methods: {
    onSelectAllChange(value) {
      value ? this.selectAll() : this.unselectAll()
    },
    selectAll() {
      this.localSelectedTasks = this.tasks.map(task => task.id)
    },
    unselectAll() {
      this.localSelectedTasks = []
    }
  }
}
</script>

<style lang="scss" scoped>
.tasks-table {
  margin-bottom: $space-xl;

  table {
    &::v-deep {
      th {
        white-space: nowrap;
      }

      th,
      td {
        vertical-align: middle;
      }
    }
  }
}
</style>
